const ExtraCreditConfigFile =
  {
      challengePoints: [{level: "total", points: 6}, {level: "1", points: 3}, {level: "2", points: 3}],
      exercises:  [{category: "MoneyMgmt", level: "1", type: "cash", amt: 1000, imgSrc: "moneyMgmt.png",
                      titleText: "Basic Financial Literacy"}, 
                   {category: "Priorities", level: "1", type: "cash", amt: 1500, imgSrc: "priorities.png",
                      titleText: "Priorities"  }, 
                   {category: "ChoosingCareer", level: "1", type: "salary", amt: 250, imgSrc: "chooseCareer.png",
                      titleText: "Choosing A Career"  },
                   {category: "LivingBelowYourMeans", level: "1", type: "salary", amt: 350, 
                      imgSrc: "livingBelowMeans.png", titleText: "Living Below Your Means"},
                   {category: "SavingMoney", level: "2", type: "salary", amt: 400, imgSrc: "saveMoney.png",
                      titleText: "Saving Money"  },
                   {category: "LearningAboutLoans", level: "2", type: "cash", amt: 2000, 
                      imgSrc: "learningAboutLoans.png", titleText: "Learning About Loans"},
                   {category: "Investments", level: "2", type: "salary", amt: 500, imgSrc: "investments.png",
                      titleText: "Investments" },
                   {category: "Insurance", level: "2", type: "cash", amt: 2050, imgSrc: "insurance.png",
                      titleText: "Insurance" },
                  ],
      dragNDropDefaults: {modalSize: "xl", buttonType: "Done"},
      textReplacements: {maxScore: 700},
      general: {defaultSalary: 45000, 
        title: "Not Quite Right, Please Try Again - Here are some helpful hint(s)"}
  };

export default ExtraCreditConfigFile;